import * as React from 'react';

interface OktaErrorProps {
  error: Error;
}

const OktaError: React.FC<OktaErrorProps> = ({ error }) => { 
  if(error.name && error.message) { 
    return <p>{error.name}: {error.message}</p>;
  }
  return <p>Error: {error.toString()}</p>;
};

export default OktaError;